var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation"},_vm._l((_vm.layerData),function(item,index){return _c('div',{key:index,staticClass:"layer",class:{
    'layer-style1': item.state === 1,
    'layer-style2': item.state === 2,
    'layer-style3': !item.show,  // 可以结合其他条件
  },on:{"click":function($event){return _vm.showLayer(item)}}},[_c('img',{staticClass:"layer-icon",attrs:{"src":item.img}}),_c('span',{staticClass:"layer-text"},[_vm._v(_vm._s(item.text))]),_c('span',{staticClass:"layer-value"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }